import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 left-0 h-screen w-full overflow-hidden z-50" }
const _hoisted_2 = { class: "w-72" }
const _hoisted_3 = {
  key: 0,
  class: "relative w-20 h-0.5 bg-neutral-50/20 overflow-hidden rounded"
}

import { gsap } from "gsap";
import { templateRef } from "@vueuse/core";
import { onMounted, ref } from "vue";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutTransition',
  setup(__props) {

const appear = ref(true);
const show = ref(true);

const lightBgRef = templateRef("lightBgRef");
const darkBgRef = templateRef("darkBgRef");
const darkContentRef = templateRef("darkContentRef");
const progressRef = templateRef("progressRef");

const tl = () =>
    gsap.timeline({
        paused: true,
        defaults: { duration: 0.4, ease: "Power2.easeInOut" },
    });

const enterTl = ref();
const leaveTl = ref();

onMounted(async () => {
    enterTl.value = tl().to(progressRef.value, {
        width: "100%",
        duration: 1.2,
        ease: "slow(0.1, 2, false)",
    });

    leaveTl.value = tl()
        .to(darkContentRef.value, { autoAlpha: 0, duration: 0.8 })
        .to(lightBgRef.value, { height: "100vh" })
        .to(lightBgRef.value, { yPercent: -100 })
        .to(darkBgRef.value, { autoAlpha: 0 });

    await showLoader();
});

async function onEnter(el: Element, done: () => any) {
    await hideLoader();
    await done();
}

async function onLeave(el: Element, done: () => any) {
    await showLoader();
    done();
}

async function showLoader() {
    document.body.style.overflow = "hidden";
    show.value = true;
    if (appear.value) {
        await enterTl.value.play(0);
    }
}

async function hideLoader() {
    await enterTl.value.then(() => leaveTl.value.play(0));
    if (appear.value) {
        appear.value = false;
    }
    document.body.style.overflow = "auto";
    show.value = false;
    leaveTl.value.progress(0).pause();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "absolute bottom-0 left-0 w-full h-0 bg-blue z-10",
        ref_key: "lightBgRef",
        ref: lightBgRef
      }, null, 512),
      _createElementVNode("div", {
        class: "absolute inset-0 flex items-center justify-center bg-black text-neutral-50",
        ref_key: "darkBgRef",
        ref: darkBgRef
      }, [
        _createElementVNode("div", {
          ref_key: "darkContentRef",
          ref: darkContentRef,
          class: "text-center space-y-12 flex flex-col justify-center items-center transform translate-y-16"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(DripversityIcon, { class: "w-full text-blue stroke-creme" })
          ]),
          (appear.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", {
                  ref_key: "progressRef",
                  ref: progressRef,
                  class: "absolute top-0 left-0 block w-0 h-full bg-neutral-50"
                }, null, 512)
              ]))
            : _createCommentVNode("", true)
        ], 512)
      ], 512)
    ], 512), [
      [_vShow, show.value]
    ]),
    _createVNode(_Transition, {
      onEnter: onEnter,
      onLeave: onLeave,
      css: false,
      appear: true,
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ], 64))
}
}

})